module.exports = __webpack_public_path__ + "components/outside-promo-page/static/intro-810dfca199a244d64a6559cacf54fdcd.svg";